//------------------------------------------------------------------------------
// This file is auto-generated.
//------------------------------------------------------------------------------
// This file was generated by NTypewriter from the C# ViewModel class with the
// same class/interface name.
//
// Do not change this file.  Any changes may cause incorrect behaviour and will
// be lost if the code is regenerated.
//------------------------------------------------------------------------------

import { UserInfoDisplayItem } from './UserInfoDisplayItem';

export class NewsReaderProfileDisplayItem extends UserInfoDisplayItem {
    LastSawNews: string | null = null;

    constructor(initializer?: Partial<NewsReaderProfileDisplayItem>) {
        super();
        if (initializer) {
            Object.assign(this, initializer);
        }
    }

    static override readonly ClassName: string = "NewsReaderProfileDisplayItem";
}
